import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaHandshake, FaBullhorn, FaStore, FaCheckCircle, FaPhone } from 'react-icons/fa'; // Ícones para Consignação
import { LuPiano } from "react-icons/lu";
import SeoHead from "../../components/Menu/components/SeoHead";
import '../../assets/css/consignacao.css'; // CSS específico para esta página

const Consignacao = () => {

  // Array com as imagens da galeria
const galleryImages = [
  { 
    id: 1, 
    src: '/img/armazenagem/1.jpg', 
    alt: 'Exposição privilegiada em ambiente apropriado e seguro' 
  },
  { 
    id: 2, 
    src: '/img/armazenagem/2.jpg', 
    alt: 'Alto fluxo de visitas à loja com grande variedade' 
  },
  { 
    id: 3, 
    src: '/img/armazenagem/3.jpg', 
    alt: 'Mais de 55 anos em São Paulo. Autoridade no assunto. ' 
  },
  { 
    id: 4, 
    src: '/img/aluguel/1.jpg', 
    alt: 'Presença nos principais market places e classificados. ' 
  },
];

const consignacaoSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Consignação de Piano",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg"
  },
  "description": "Deixe seu piano em consignação conosco para venda. Realizamos divulgação, exposição em loja e reparos necessários para atrair compradores.",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo"
  },
  "url": "https://pianoswaldir.com.br/consignacao"
};



  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-rotatividade das imagens
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000); // Muda a cada 5 segundos
    
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];
  return (
    <div className="consignacao-container">
      <SeoHead
  title="Consignação de Pianos | Venda Seu Piano com Waldir Pianos"
  description="Precisa vender seu piano? Deixe-o em consignação conosco. Fazemos a divulgação, exposição e reparos para atrair compradores e garantir um bom negócio."
  keywords="consignação piano, vender piano, piano à venda, loja de pianos, Waldir Pianos"
  image="/img/consignacao/1.jpg" 
  url="https://pianoswaldir.com.br/consignacao"
  canonicalUrl="https://pianoswaldir.com.br/consignacao"
  schemaMarkup={consignacaoSchema}
/>
      {/* Cabeçalho */}
      <motion.header
        className="consignacao-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="consignacao-header-content">
          <motion.h1
            className="consignacao-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <FaHandshake className="consignacao-title-icon" />
            Consignação
            <span className="consignacao-title-decoration"></span>
          </motion.h1>

          <motion.p
            className="consignacao-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Facilitando a venda do seu piano
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="consignacao-main-content">
        {/* Seção de Texto */}
        <motion.section
          className="consignacao-text-section"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div
            className="consignacao-text-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <h2 className="consignacao-section-title">
              <FaBullhorn className="consignacao-section-icon" />
              Maximize o Potencial de Venda
            </h2>

            <p className="consignacao-classic-text">
              "Precisando desocupar espaço ou Procurando um comprador para o seu piano, mas não sabe onde divulgar?"
            </p>

            <div className="consignacao-modern-text">
              <p>Você pode deixar em consignação conosco. Fazemos toda divulgação em nossos canais e lista de contatos, mantemos em exposição em nossa loja e executamos todos reparos necessários para atrair compradores.</p>
              <p>Assim que conseguirmos um bom negócio, repassamos o valor combinado.</p>
            </div>

            <div className="consignacao-benefits-grid">
              <div className="consignacao-benefit-item">
                <FaBullhorn className="consignacao-benefit-icon" />
                <span>Ampla divulgação nos nossos canais</span>
              </div>
              <div className="consignacao-benefit-item">
                <FaStore className="consignacao-benefit-icon" />
                <span>Exposição em nossa loja física</span>
              </div>
              <div className="consignacao-benefit-item">
                <FaCheckCircle className="consignacao-benefit-icon" />
                <span>Reparos necessários para valorização</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

<motion.section
        className="armazenagem-gallery-section"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <h3 className="armazenagem-gallery-title">Consignação</h3>
        
        <motion.div 
          className="armazenagem-gallery-container"
          key={currentImageIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="armazenagem-piano-image">
            <img 
              src={currentImage.src} 
              alt={currentImage.alt}
              className="armazenagem-gallery-image"
            />
            <div className="armazenagem-image-overlay">
              <span className="armazenagem-piano-description">
                {currentImage.alt}
              </span>
            </div>
          </div>
        </motion.div>
        
        {/* Pontos de navegação */}
        <div className="armazenagem-gallery-dots">
          {galleryImages.map((_, index) => (
            <button
              key={index}
              className={`armazenagem-dot ${index === currentImageIndex ? 'armazenagem-dot-active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </motion.section>
      </div>

      {/* Rodapé */}
      <motion.footer
        className="consignacao-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="consignacao-footer-text">Quer vender seu piano de forma descomplicada?</p>
        <motion.a
          href="tel:1122565987"
          className="consignacao-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
  );
};

export default Consignacao;